import React, { Component } from 'react';
import { connect } from "react-redux";
import SettingsHeader from "../SettingsHeader";
import BannedUsersDatatable  from "./BannedUsersDatatable";
import {removeBannedUser} from "../../../actions/actions";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class BannedUsers extends Component {

    constructor(props) {
        super(props);
		
		this.state = {
            data: props.chatprop.bannedUsers
        };

		this.removeBannedUser = this.removeBannedUser.bind(this);
    }
	
	removeBannedUser(e,id){
				this.props.dispatch(removeBannedUser({
                    id:id
                }));
        e.preventDefault();
    }

    render() {
        const { t } = this.props;
        return (
            <div className="banned-users-list-datatable" style={{"marginTop":"5px","padding":"10px"}}>
                <div style={{marginBottom:"20px"}} />
                <BannedUsersDatatable type="all"  id="bannedUsers" removeBannedUser={this.removeBannedUser} />
            </div>
        );
    }
}

export default BannedUsers;
